import { Box, xcss } from '@atlaskit/primitives';
import { messages } from '@databases/intl/messages';
import React from 'react';
import { FormattedMessage } from 'react-intl-next';

const thinkingStyles = xcss({
  color: 'color.text.subtlest'
});

export const AiFieldThinkingPlaceholder = () => (
  <Box xcss={thinkingStyles}>
    <FormattedMessage {...messages['field-value.ai-field-thinking']} />
  </Box>
);
